import { images } from '../constants';

const blogs = [
  {
    id: 1,
    image: images.blog1,
    category: "Venue Selection",
    date: "10 May, 2025",
    admin: "Admin",
    heading: "How to Pick Your Perfect Venue",
    important: {
      content: "Picking the right venue sets the tone for your entire wedding. Make your choice count! The right venue not only accommodates your guests but also complements your theme and personal style.",
      intro: "Wedding Planner"
    },
    paragraph: {
      para1: "Choosing the right venue is crucial for creating the perfect atmosphere for your wedding. With countless options available, it can be overwhelming to find a location that reflects your unique style and meets your specific needs. This guide will help you navigate through the important factors to consider, ensuring that your chosen venue enhances your special day.",
      para2: "From capacity and location to aesthetics and amenities, we guide you through the essential aspects of venue selection. Think about the vibe you want to create: whether it's a romantic garden, a chic urban loft, or a rustic barn. Each setting offers its own charm, so take the time to envision how you want your wedding to look and feel.",
      para3: "Explore our comprehensive checklist and expert tips to find the venue of your dreams. Consider factors like the time of year, weather conditions, and the convenience of location for your guests. Your perfect wedding starts with the perfect location, and we're here to help you every step of the way!",
      para4: "Visualize your dream venue with our gallery of beautiful locations. Let these images inspire your wedding planning journey! Each featured venue has its own unique qualities and charm, perfect for making unforgettable memories. We encourage you to consider these options as you embark on the exciting adventure of planning your wedding."
    },
    gallery: [
      images.blog1Gallery1,
      images.blog1Gallery2
    ],
    tags: ["Venue", "Bridal", "Trends"],
    comments: [
      {
        id: 1,
        image: images.blog1Comment1,
        name: "Benjamin Alexander",
        date: "Mar 01, 2025",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur.",
        replies: [
          {
            id: 1,
            image: images.blog1Comment2,
            name: "Isabella Grace",
            date: "Mar 02, 2025",
            content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur."
          }
        ]
      },
      {
        id: 2,
        image: images.blog1Comment3,
        name: "Samuel James",
        date: "Mar 02, 2025",
        content: "Lorem ipsum dolor sit amet, consectetur adipisicing elit. Molestias sapiente ullam esse laudantium corporis pariatur.",
        replies: []
      }
    ]
  },
  {
    id: 2,
    image: images.blog2,
    category: "Wedding Planning",
    date: "05 May, 2025",
    admin: "Admin",
    heading: "Budgeting for Your Dream Wedding",
    important: {
      content: "Creating a wedding budget isn't just about cutting costs—it's about prioritizing what truly matters to you. A well-planned budget empowers you to design a celebration that reflects your vision while staying financially confident.",
      intro: "Wedding Expert"
    },
    paragraph: {
      para1: "Dream weddings can be magical, but without proper planning, expenses can quickly spiral out of control. Setting a realistic budget is the first step toward turning your vision into reality—without the stress.",
      para2: "From venue and catering to attire and entertainment, it’s important to break down your costs and assign values to each element. Focus on areas where you’re willing to splurge and where you can save without compromising the experience.",
      para3: "Remember to include hidden costs like gratuities, transportation, or last-minute decor adjustments. Always have a buffer fund for unexpected expenses. This foresight can save you from last-minute financial panic.",
      para4: "Use our downloadable budget planner and real-life case studies to understand typical wedding costs and how couples like you stayed on track. Your dream wedding is possible—with the right plan in place."
    },
    gallery: [
      images.blog2Gallery1,
      images.blog2Gallery2
    ],
    tags: ["Budget", "Bridal", "Trends"],
    comments: [
      {
        id: 1,
        image: images.blog2Comment1,
        name: "Sophia Bennett",
        date: "Oct 12, 2025",
        content: "This article helped me so much! Budgeting felt overwhelming, but this broke it down clearly.",
        replies: [
          {
            id: 1,
            image: images.blog2Comment2,
            name: "Wedding Planner",
            date: "Oct 13, 2025",
            content: "We’re so glad it helped! Planning ahead makes all the difference."
          }
        ]
      },
      {
        id: 2,
        image: images.blog2Comment3,
        name: "Liam Carter",
        date: "Oct 14, 2025",
        content: "Loved the tips on hidden costs. That buffer tip saved me big time!"
      }
    ]
  },
  {
    id: 3,
    image: images.blog3,
    category: "Bridal Fashion",
    date: "28 April, 2025",
    admin: "Admin",
    heading: "Bridal Jewelry: What to Wear",
    important: {
      content: "The right bridal jewelry doesn’t overpower—it enhances your dress, complements your style, and adds a sparkling finishing touch that makes you feel absolutely radiant.",
      intro: "Style Advisor"
    },
    paragraph: {
      para1: "Your wedding jewelry should reflect your personality and work in harmony with your dress and hairstyle. Whether you're going for vintage elegance or modern chic, the pieces you choose help complete your bridal look.",
      para2: "Stick to the golden rule—less is more. If your gown is heavily embellished, go for minimal pieces like diamond studs or a delicate pendant. For simpler dresses, you can add statement earrings or a bold necklace to add drama.",
      para3: "Consider metals that match your dress tone—ivory pairs beautifully with gold, while bright white works best with platinum or silver. Don’t forget to coordinate your jewelry with your engagement ring for a cohesive finish.",
      para4: "Need help deciding? Our bridal stylists have put together inspiration boards and expert advice to guide you in choosing jewelry that feels just right for your special day."
    },
    gallery: [
      images.blog3Gallery1,
      images.blog3Gallery2
    ],
    tags: ["Jewelry", "Bridal", "Trends"],
    comments: [
      {
        id: 1,
        image: images.blog3Comment1,
        name: "Emily Rose",
        date: "Oct 16, 2025",
        content: "Loved the style-matching tips! I never thought about how dress color affects jewelry choice."
      },
      {
        id: 2,
        image: images.blog3Comment2,
        name: "Noah Davis",
        date: "Oct 17, 2025",
        content: "My fiancée found this post super helpful. Great advice and stunning visuals!"
      }
    ]
  },
  {
    id: 4,
    image: images.blog4,
    category: "Wedding Themes",
    date: "20 April, 2025",
    admin: "Admin",
    heading: "5 Popular Wedding Themes for 2025",
    important: {
      content: "Your wedding theme sets the tone for your big day—it reflects your personality and creates a memorable experience for you and your guests.",
      intro: "Trend Spotlight"
    },
    paragraph: {
      para1: "From intimate garden affairs to bold and glamorous celebrations, 2025 is shaping up to be all about individuality and intentional design. Couples are choosing themes that tell their unique story.",
      para2: "**1. Modern Minimalist:** Clean lines, neutral palettes, and architectural florals are at the heart of this sleek style.",
      para3: "**2. Garden Romance:** Think lush florals, soft lighting, and vintage accents for a timeless outdoor vibe.",
      para4: "**3. Boho Chic:** A favorite for free-spirited couples—macramé décor, dried florals, and earthy tones dominate this trend.",
      para5: "**4. Classic Elegance:** Traditional meets luxury with crystal chandeliers, rich fabrics, and black-tie style.",
      para6: "**5. Coastal Breeze:** Light blues, sandy neutrals, and ocean-inspired details make this a dreamy option for beach lovers.",
      para7: "Each theme can be tailored to your venue and vision. The key is choosing a style that feels authentic to your relationship and lifestyle."
    },
    gallery: [
      images.blog4Gallery1,
      images.blog4Gallery2
    ],
    tags: ["Themes", "Trends", "Bridal"],
    comments: [
      {
        id: 1,
        image: images.blog4Comment1,
        name: "Sophia Lane",
        date: "Oct 21, 2025",
        content: "Boho Chic is exactly what I was looking for—this blog gave me so many ideas!"
      },
      {
        id: 2,
        image: images.blog4Comment2,
        name: "Liam Carter",
        date: "Oct 22, 2025",
        content: "We’re planning a coastal wedding—thanks for the inspiration!"
      }
    ]
  },
  {
    id: 5,
    image: images.blog5,
    category: "Real Weddings",
    date: "10 April, 2025",
    admin: "Admin",
    heading: "A Magical Forest Wedding: Anna & James",
    important: {
      content: "Deep in the heart of an enchanted woodland, Anna and James celebrated their love with a whimsical forest wedding filled with emotion, nature, and unforgettable details.",
      intro: "Real Love Story"
    },
    paragraph: {
      para1: "Anna and James always dreamed of a wedding surrounded by trees, birdsong, and natural beauty. Their special day brought that vision to life in the most enchanting way.",
      para2: "The ceremony took place under a canopy of towering pines, where soft petals lined the mossy aisle. The couple exchanged vows with the sound of a nearby stream gently flowing—nature truly served as the most magical backdrop.",
      para3: "The reception was equally spellbinding, featuring rustic wooden tables adorned with fern runners, flickering candles, and hand-picked wildflowers. Guests enjoyed gourmet bites under twinkling fairy lights strung from branch to branch.",
      para4: "From their botanical-inspired wedding cake to the eco-friendly favors, every detail reflected Anna and James' love for the outdoors and each other.",
      para5: "This forest wedding wasn’t just a celebration—it was an experience. Full of heart, harmony, and natural wonder, it reminded everyone that love is most beautiful when it’s grounded in what’s real."
    },
    gallery: [
      images.blog5Gallery1,
      images.blog5Gallery2
    ],
    tags: ["Themes", "Venue", "Bridal"],
    comments: [
      {
        id: 1,
        image: images.blog5Comment1,
        name: "Maya Rivers",
        date: "Oct 29, 2025",
        content: "This is straight out of a fairytale—absolutely stunning!"
      },
      {
        id: 2,
        image: images.blog5Comment2,
        name: "Ethan Park",
        date: "Oct 30, 2025",
        content: "Love the eco-friendly touches. Truly inspiring wedding!"
      }
    ]
  },
  {
    id: 6,
    image: images.blog6,
    category: "Venue Selection",
    date: "29 March, 2025",
    admin: "Admin",
    heading: "Choosing a Beach Wedding Venue",
    important: {
      content: "Dreaming of waves crashing in the background as you say ‘I do’? A beach wedding can be unforgettable, but picking the right location is key.",
      intro: "Planning by the Sea"
    },
    paragraph: {
      para1: "Beach weddings offer a natural backdrop and a relaxed, romantic vibe. But with so many coastal locations to choose from, how do you find the perfect one?",
      para2: "Start by deciding whether you want a private beach, a resort venue, or a public shoreline. Each comes with different levels of privacy, convenience, and cost.",
      para3: "Consider the logistics—parking, restrooms, permits, weather conditions, and tides. A beautiful view means nothing if guests can't reach the ceremony or the setup gets washed away.",
      para4: "Also think about your wedding style. Do you want a barefoot boho feel, a luxurious tropical celebration, or a nautical theme? Choose a venue that enhances your vision.",
      para5: "Lastly, always visit the beach before booking. Feel the breeze, check the sunset view, and imagine your big day there. It’s not just a location—it’s a vibe."
    },
    gallery: [
      images.blog6Gallery1,
      images.blog6Gallery2
    ],
    tags: ["Venue", "Trends", "Bridal"],
    comments: [
      {
        id: 1,
        image: images.blog6Comment1,
        name: "Lena Carter",
        date: "Nov 6, 2025",
        content: "Great tips! I didn’t think about checking the tides before booking!"
      },
      {
        id: 2,
        image: images.blog6Comment2,
        name: "Jordan Blake",
        date: "Nov 7, 2025",
        content: "We just booked a beach venue and this article was so helpful. Thanks!"
      }
    ]
  },
  {
    id: 7,
    image: images.blog7,
    category: "Bridal Fashion",
    date: "21 March, 2025",
    admin: "Admin",
    heading: "Top Bridal Gown Trends for 2025",
    important: {
      content: "From bold sleeves to sustainable fabrics, bridal fashion in 2025 is all about individuality and elegance. Discover the styles that brides are loving this season.",
      intro: "What’s Hot This Year"
    },
    paragraph: {
      para1: "This year’s bridal gown trends are redefining traditional silhouettes with modern flair. Designers are mixing timeless elegance with playful details.",
      para2: "One standout trend is puff sleeves—dramatic, romantic, and totally regal. They add volume and personality to even the simplest gown.",
      para3: "Minimalist gowns are still going strong, with clean lines and sleek fabrics offering understated sophistication. Think Meghan Markle-inspired elegance.",
      para4: "Eco-conscious brides are embracing sustainable fabrics like organic silk and recycled lace. It’s fashion that makes a statement—and a difference.",
      para5: "Color is also sneaking in. Blush tones, soft blues, and champagne hues are popping up for brides who want something a little unexpected yet dreamy."
    },
    gallery: [
      images.blog7Gallery1,
      images.blog7Gallery2
    ],
    tags: ["Gown", "Trends", "Bridal"],
    comments: [
      {
        id: 1,
        image: images.blog7Comment1,
        name: "Ava Montgomery",
        date: "Nov 11, 2025",
        content: "Loving the puff sleeve trend—so romantic and vintage-chic!"
      },
      {
        id: 2,
        image: images.blog7Comment2,
        name: "Sophia Lin",
        date: "Nov 12, 2025",
        content: "I'm going for a minimalist gown, and this article gave me great ideas."
      }
    ]
  },
  {
    id: 8,
    image: images.blog8,
    category: "Bridal Fashion",
    date: "12 March, 2025",
    admin: "Admin",
    heading: "Best Shoes for Your Wedding Day",
    important: {
      content: "Your wedding shoes should be stylish, comfortable, and perfect for dancing the night away. Discover the best footwear picks for every bride.",
      intro: "Finding the Perfect Fit"
    },
    paragraph: {
      para1: "When choosing your wedding day shoes, comfort is just as important as style. You’ll be on your feet for hours, from the walk down the aisle to your last dance.",
      para2: "Classic pumps and strappy sandals remain timeless choices, offering both elegance and versatility. They pair beautifully with most dress styles.",
      para3: "For outdoor weddings, consider block heels or wedges—they provide extra stability without compromising on chic design.",
      para4: "If you want something playful and modern, embellished sneakers or satin ballet flats can be both comfy and fashionable.",
      para5: "Don’t forget to break in your shoes before the big day! Walk around in them at home to avoid blisters and sore feet."
    },
    gallery: [
      images.blog8Gallery1,
      images.blog8Gallery2
    ],
    tags: ["Shoes", "Bridal", "Trends"],
    comments: [
      {
        id: 1,
        image: images.blog8Comment1,
        name: "Rachel Green",
        date: "Nov 13, 2025",
        content: "I wore block heels for my garden wedding—lifesaver!"
      },
      {
        id: 2,
        image: images.blog8Comment2,
        name: "Emily Carter",
        date: "Nov 14, 2025",
        content: "Great tip about breaking them in. I learned that the hard way!"
      }
    ]
  },
  {
    id: 9,
    image: images.blog9,
    category: "Venue Selection",
    date: "2 March, 2025",
    admin: "Admin",
    heading: "Tips for Choosing the Ideal Wedding Venue",
    important: {
      content: "Your wedding venue sets the tone for your entire celebration. From guest count to ambiance, here’s how to choose the perfect place for your big day.",
      intro: "Setting the Stage for 'I Do'"
    },
    paragraph: {
      para1: "Start by determining your guest list size and budget—these two factors will help narrow down your venue options significantly.",
      para2: "Think about your wedding theme and personal style. Whether you prefer a romantic vineyard, a rustic barn, or a sleek city rooftop, your venue should match your vision.",
      para3: "Consider the location’s accessibility for guests. Venues with on-site accommodations or nearby hotels are especially convenient for out-of-town visitors.",
      para4: "Visit venues in person, if possible, to get a feel for the space, lighting, and overall vibe. Pictures rarely capture the full experience.",
      para5: "Don’t forget about backup plans for weather! Especially for outdoor weddings, having a covered option is essential for peace of mind."
    },
    gallery: [
      images.blog9Gallery1,
      images.blog9Gallery2
    ],
    tags: ["Venue", "Trends", "Bridal"],
    comments: [
      {
        id: 1,
        image: images.blog9Comment1,
        name: "Sophie Lane",
        date: "Nov 19, 2025",
        content: "Visiting venues in person made all the difference for us!"
      },
      {
        id: 2,
        image: images.blog9Comment2,
        name: "Jason Moore",
        date: "Nov 20, 2025",
        content: "Totally agree on having a weather backup. We almost had a rain disaster!"
      }
    ]
  },
  {
    id: 10,
    image: images.blog10,
    category: "Wedding Planning",
    date: "22 February, 2025",
    admin: "Admin",
    heading: "How to Plan a Wedding Budget That Works",
    important: {
      content: "Creating a realistic wedding budget is key to planning your dream day without the stress. Here’s how to break down your costs and stay on track.",
      intro: "Budgeting for Bliss"
    },
    paragraph: {
      para1: "Begin by discussing your total available budget with your partner and any contributing family members. Knowing your limits early helps avoid overspending.",
      para2: "List out your priorities—whether it’s the venue, catering, or photography—so you can allocate funds accordingly and cut costs in less important areas.",
      para3: "Don’t forget about hidden or unexpected expenses like tips, dress alterations, or overtime fees for vendors. Build a buffer into your budget.",
      para4: "Use budgeting tools or spreadsheets to track every expense. Staying organized helps you monitor your spending and make adjustments in real time.",
      para5: "Review and adjust your budget as plans evolve. Flexibility is key when dealing with changing quotes or guest counts."
    },
    gallery: [
      images.blog10Gallery1,
      images.blog10Gallery2
    ],
    tags: ["Budget", "Bridal", "Trends"],
    comments: [
      {
        id: 1,
        image: images.blog10Comment1,
        name: "Olivia Hart",
        date: "Nov 23, 2025",
        content: "I wish we had planned for those hidden costs—great advice!"
      },
      {
        id: 2,
        image: images.blog10Comment2,
        name: "Daniel Reyes",
        date: "Nov 24, 2025",
        content: "Tracking everything in a spreadsheet saved us so much stress."
      }
    ]
  },
  {
    id: 11,
    image: images.blog11,
    category: "Bridal Fashion",
    date: "18 February, 2025",
    admin: "Admin",
    heading: "Bridal Jewelry Guide: What You Should Wear",
    important: {
      content: "From elegant earrings to statement necklaces, bridal jewelry should complement your gown and personal style. Here's how to choose the perfect pieces.",
      intro: "Shine in Every Detail"
    },
    paragraph: {
      para1: "Start by considering your dress neckline—this will guide whether a necklace, statement earrings, or both will work best.",
      para2: "Less is more. Choose pieces that enhance your look rather than compete with your gown’s details like lace, beading, or embellishments.",
      para3: "For a timeless look, pearls and diamonds are classic choices, while colored gemstones can add a bold, modern twist.",
      para4: "Make sure your metals match. Coordinate gold, silver, or rose gold jewelry with your dress accents and other accessories like your veil or hairpiece.",
      para5: "Above all, wear what feels like you. Your wedding day style should reflect your personality and make you feel radiant."
    },
    gallery: [
      images.blog11Gallery1,
      images.blog11Gallery2
    ],
    tags: ["Jewelry", "Bridal", "Trends"],
    comments: [
      {
        id: 1,
        image: images.blog11Comment1,
        name: "Claire Bennett",
        date: "Nov 27, 2025",
        content: "Pearl drop earrings were my favorite detail—simple and stunning!"
      },
      {
        id: 2,
        image: images.blog11Comment2,
        name: "Maya Singh",
        date: "Nov 28, 2025",
        content: "Matching my necklace to my dress neckline made such a difference!"
      }
    ]
  },
  {
    id: 12,
    image: images.blog12,
    category: "Wedding Themes",
    date: "4 February, 2025",
    admin: "Admin",
    heading: "Top 5 Trending Wedding Themes for 2025",
    important: {
      content: "From nature-inspired setups to bold color palettes, 2025 is bringing fresh energy to wedding themes. Discover the top trends couples are loving this year.",
      intro: "Themes That Tell Your Story"
    },
    paragraph: {
      para1: "1. **Eco-Chic Weddings** – Sustainability meets style with reusable décor, local florals, and nature-forward elements that reduce your wedding’s footprint.",
      para2: "2. **Modern Minimalism** – Think clean lines, monochrome tones, and refined elegance. Perfect for couples who love a sleek, contemporary vibe.",
      para3: "3. **Vintage Revival** – Retro is in! From 1920s glamour to 90s nostalgia, vintage themes bring a unique and charming flair to your big day.",
      para4: "4. **Whimsical Garden Parties** – Outdoor weddings filled with fairy lights, wildflowers, and pastel palettes continue to be a dreamy favorite.",
      para5: "5. **Bold & Colorful Celebrations** – Say goodbye to safe neutrals. Bright hues, playful patterns, and dramatic florals are making weddings more vibrant than ever."
    },
    gallery: [
      images.blog12Gallery1,
      images.blog12Gallery2
    ],
    tags: ["Themes", "Trends", "Bridal"],
    comments: [
      {
        id: 1,
        image: images.blog12Comment1,
        name: "Lena Murphy",
        date: "Dec 1, 2025",
        content: "We’re going with a whimsical garden theme—love seeing it on this list!"
      },
      {
        id: 2,
        image: images.blog12Comment2,
        name: "Aarav Patel",
        date: "Dec 2, 2025",
        content: "The vintage revival trend is exactly what we’ve been planning for!"
      }
    ]
  }
];

export default blogs;